// 初始化数据
const modal = {
  searchResult: [], //查询结果数据
  selectedRowKeys: [],
  selectedRowItems: [],
  searchParams: {
    // customerCode: {value: 100003, children: 'sss'}
  }, // 搜索传值
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 20, // 当前分页数
  modalTuttonLoading: false,
  tableLoading: false,
  buttonLoading: false,
  detailsList: {},
  RecordVisible: false,
};
export default modal;
